import { render, staticRenderFns } from "./servicePeriod.vue?vue&type=template&id=45e01f4e&scoped=true&"
import script from "./servicePeriod.vue?vue&type=script&lang=js&"
export * from "./servicePeriod.vue?vue&type=script&lang=js&"
import style0 from "./servicePeriod.vue?vue&type=style&index=0&id=45e01f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e01f4e",
  null
  
)

export default component.exports